import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { Auth } from '../services/auth';

export const authGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  return auth.hasValidSession().pipe(
    map((hasValidSession) => hasValidSession ? true : router.createUrlTree(['/login'])),
  );
};
